import React from 'react';
import { ShoppingBag, Menu, Search } from 'lucide-react';
import { CartContextType } from '../types';

interface NavbarProps {
  cart: CartContextType;
  onOpenMenu: () => void;
  logoUrl?: string;
  onCategoryClick?: (category: string) => void;
}

export const Navbar: React.FC<NavbarProps> = ({ cart, onOpenMenu, logoUrl, onCategoryClick }) => {
  return (
    <nav className="sticky top-0 z-50 bg-white border-b border-gray-100 h-16 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 h-full flex justify-between items-center">
        
        {/* Left: Hamburger Menu & Logo */}
        <div className="flex items-center gap-4">
            <button 
              onClick={onOpenMenu}
              className="p-2 -ml-2 text-gray-800"
            >
              <Menu size={28} strokeWidth={1.5} />
            </button>

            {/* Logo */}
            <div className="flex justify-center items-center cursor-pointer" onClick={() => window.location.reload()}>
               {logoUrl ? (
                 <img src={logoUrl} alt="Store Logo" className="h-10 object-contain" />
               ) : (
                 <div className="flex items-center gap-2">
                   <div className="bg-black text-white p-1 rounded-sm">
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="white"><path d="M20 12V22H4V12H20ZM20 10H4C2.9 10 2 10.9 2 12V22C2 23.1 2.9 24 4 24H20C21.1 24 22 23.1 22 22V12C22 10.9 21.1 10 20 10ZM12 2L4 6V8H20V6L12 2Z"/></svg>
                   </div>
                   <span className="font-black text-2xl tracking-tighter uppercase font-sans">SHOEBHAI</span>
                 </div>
               )}
            </div>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8 ml-8">
                <button onClick={() => onCategoryClick?.('Home')} className="text-sm font-bold text-gray-700 hover:text-black uppercase tracking-wide">Home</button>
                <button onClick={() => onCategoryClick?.('Men')} className="text-sm font-bold text-gray-700 hover:text-black uppercase tracking-wide">Men</button>
                <button onClick={() => onCategoryClick?.('Women')} className="text-sm font-bold text-gray-700 hover:text-black uppercase tracking-wide">Women</button>
                <button onClick={() => onCategoryClick?.('Kids')} className="text-sm font-bold text-gray-700 hover:text-black uppercase tracking-wide">Kids</button>
                <button onClick={() => onCategoryClick?.('Sale')} className="text-sm font-bold text-red-600 hover:text-red-700 uppercase tracking-wide">Sale</button>
            </div>
        </div>

        {/* Right: Search & Cart */}
        <div className="flex items-center gap-2">
          <button className="p-2 text-gray-800">
            <Search size={24} strokeWidth={1.5} />
          </button>
          
          <button 
            onClick={() => cart.setIsCartOpen(true)}
            className="relative p-2 text-gray-800"
          >
            <ShoppingBag size={24} strokeWidth={1.5} />
            {cart.itemCount > 0 && (
              <span className="absolute top-0 right-0 inline-flex items-center justify-center w-4 h-4 text-[10px] font-bold leading-none text-black transform bg-yellow-400 rounded-full">
                {cart.itemCount}
              </span>
            )}
          </button>
        </div>

      </div>
    </nav>
  );
};